var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 10.199,
    y: 133.609,
    style: {
      fill: "#E8E8E8"
    },
    width: 491.602,
    height: 324.957
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.199,
    y: 249.564,
    style: {
      fill: "#F07057"
    },
    width: 491.602,
    height: 118.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.586,
    y: 249.564,
    style: {
      fill: "#F07057"
    },
    width: 144.829,
    height: 209.002
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F07057"
    },
    d: "M59.76,200.611L59.76,200.611c-27.372,0-49.561-22.188-49.561-49.56v-97.62h99.121v97.62 C109.32,178.422,87.132,200.611,59.76,200.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F07057"
    },
    d: "M157.88,200.611L157.88,200.611c-27.372,0-49.561-22.189-49.561-49.561V53.431h99.121v97.62 C207.441,178.422,185.251,200.611,157.88,200.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F07057"
    },
    d: "M256,200.611L256,200.611c-27.372,0-49.561-22.189-49.561-49.561V53.431h99.121v97.62 C305.561,178.422,283.372,200.611,256,200.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F07057"
    },
    d: "M354.12,200.611L354.12,200.611c-27.372,0-49.561-22.189-49.561-49.561V53.431h99.121v97.62 C403.68,178.422,381.492,200.611,354.12,200.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F07057"
    },
    d: "M452.24,200.611L452.24,200.611c-27.372,0-49.561-22.189-49.561-49.561V53.431h99.122v97.62 C501.801,178.422,479.611,200.611,452.24,200.611z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.801,468.767c5.632,0,10.199-4.567,10.199-10.199V53.431c0-5.632-4.567-10.199-10.199-10.199H10.199 C4.567,43.232,0,47.799,0,53.431v405.138c0,5.632,4.567,10.199,10.199,10.199h491.602V468.767z M491.602,133.609v17.442 c0,21.704-17.658,39.362-39.362,39.362c-19.382,0-35.524-14.084-38.76-32.553c0.255-2.237,0.4-4.506,0.4-6.809V63.63h77.722V133.609 z M491.602,357.678H338.614v-97.912h152.988V357.678z M328.414,239.368H183.586H20.398v-43.409 c10.523,9.234,24.295,14.851,39.362,14.851c20.298,0,38.255-10.181,49.06-25.696c10.805,15.515,28.761,25.696,49.059,25.696 s38.255-10.181,49.06-25.696c10.805,15.515,28.762,25.696,49.06,25.696s38.255-10.181,49.06-25.696 c10.805,15.515,28.762,25.696,49.06,25.696c20.298,0,38.254-10.181,49.059-25.696c10.805,15.515,28.762,25.696,49.06,25.696 c15.067,0,28.839-5.617,39.362-14.851v43.409H328.414z M173.386,357.678H20.398v-97.912h152.988V357.678z M119.52,151.051V63.63 h76.72v87.42c0,2.303,0.145,4.572,0.4,6.809c-3.236,18.469-19.378,32.553-38.76,32.553c-19.381,0-35.523-14.084-38.759-32.553 C119.376,155.623,119.52,153.354,119.52,151.051z M217.64,151.051V63.63h76.721v87.42c0,2.303,0.145,4.572,0.4,6.809 c-3.236,18.469-19.378,32.553-38.76,32.553s-35.524-14.084-38.76-32.553C217.495,155.623,217.64,153.354,217.64,151.051z  M315.76,151.051V63.63h76.72v87.42c0,2.303,0.145,4.572,0.4,6.809c-3.236,18.469-19.378,32.553-38.759,32.553 c-19.382,0-35.524-14.084-38.76-32.553C315.615,155.623,315.76,153.354,315.76,151.051z M20.398,63.63H98.12v87.42 c0,2.303,0.145,4.572,0.4,6.809c-3.236,18.469-19.378,32.553-38.76,32.553c-21.704,0-39.362-17.658-39.362-39.362v-17.442 C20.398,133.609,20.398,63.63,20.398,63.63z M20.398,378.077h152.988v70.292H20.398V378.077z M193.785,448.369V259.766h124.43 v188.603H193.785z M338.614,448.369v-70.292h152.988v70.292H338.614z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.183,344.733c-5.632,0-10.199,4.567-10.199,10.199v9.179c0,5.632,4.567,10.199,10.199,10.199 s10.199-4.567,10.199-10.199v-9.179C224.382,349.3,219.815,344.733,214.183,344.733z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M396.749,349.832h4.08c5.632,0,10.199-4.567,10.199-10.199c0-5.632-4.567-10.199-10.199-10.199h-4.08 c-5.632,0-10.199,4.567-10.199,10.199C386.55,345.265,391.117,349.832,396.749,349.832z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M432.446,349.832h38.757c5.632,0,10.199-4.567,10.199-10.199c0-5.632-4.567-10.199-10.199-10.199h-38.757 c-5.632,0-10.199,4.567-10.199,10.199C422.247,345.265,426.814,349.832,432.446,349.832z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopFilled);
export default __webpack_public_path__ + "static/media/shop-filled.d8680cca88a7f1cb2fef73fe73f33819.svg";
export { ForwardRef as ReactComponent };